import { Products } from './Products';

export default Products;
